// frontend/src/components/Settings/PartsMarkups.tsx
import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Input, InputNumber, Radio, Space, Popconfirm, App } from 'antd';
import { partMarkupApi } from '../../services/api';
import type { PartMarkupPreset } from '../../types';

export function PartsMarkups() {
  const { message } = App.useApp();
  const [presets, setPresets] = useState<PartMarkupPreset[]>([]);
  const [newName, setNewName] = useState(''); const [newMarkup, setNewMarkup] = useState<number>(40);

  const load = async () => { try { setPresets((await partMarkupApi.getAll()).data); } catch { message.error('Failed to load presets'); } };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async () => {
    if (!newName.trim()) return message.error('Name required');
    try { await partMarkupApi.create({ name: newName.trim(), markup_percentage: newMarkup }); setNewName(''); await load(); message.success('Preset added'); }
    catch { message.error('Failed to add preset'); }
  };
  const saveMarkup = async (r: PartMarkupPreset, markup_percentage: number) => {
    try {
      await partMarkupApi.update(r.id, { markup_percentage });
      await load();
    } catch { message.error('Failed to update preset'); }
  };
  const makeDefault = async (id: number) => { try { await partMarkupApi.setDefault(id); await load(); } catch { message.error('Failed'); } };
  const remove = async (id: number) => {
    try { await partMarkupApi.delete(id); await load(); message.success('Deleted'); }
    catch (e: any) { message.error(e?.response?.data?.error || 'Failed to delete'); }
  };

  return (
    <Card title="Parts Markups" size="small">
      <Table rowKey="id" dataSource={presets} pagination={false} size="small"
        columns={[
          { title: 'Name', dataIndex: 'name' },
          { title: 'Markup (%)', dataIndex: 'markup_percentage', render: (v: number, r: PartMarkupPreset) => (
            <InputNumber min={0} max={1000} defaultValue={v} suffix="%" onBlur={(e) => { const nv = Number((e.target as HTMLInputElement).value); if (nv !== v) saveMarkup(r, nv); }} aria-label={`markup-${r.name}`} />) },
          { title: 'Default', dataIndex: 'is_default', render: (_: any, r: PartMarkupPreset) => (
            <Radio checked={r.is_default === 1} onChange={() => makeDefault(r.id)} />) },
          { title: '', render: (_: any, r: PartMarkupPreset) => (
            <Popconfirm title="Delete this preset?" onConfirm={() => remove(r.id)}><Button size="small" danger>Delete</Button></Popconfirm>) },
        ]} />
      <Space style={{ marginTop: 12 }}>
        <Input placeholder="Preset name (e.g. OEM)" value={newName} onChange={e => setNewName(e.target.value)} style={{ width: 180 }} />
        <InputNumber min={0} max={1000} value={newMarkup} onChange={v => setNewMarkup(Number(v) || 0)} suffix="%" aria-label="new-markup" />
        <Button type="primary" onClick={add}>Add preset</Button>
      </Space>
    </Card>
  );
}
